import { get } from "lodash";
import React, { useMemo } from "react";
import { useFormState } from "react-final-form";
import { useSelector } from "react-redux";
import { CustomVariableFormFields } from "../CustomVariableDialog";
import FormulaValue from "../FormulaValue";
import ValueFields from "../ValueFields";
import { getFormulaDisplayValue, getFormulaValueTimingInfo, getFormulaValueFieldsConfigured, CustomVariableValueStatus, } from "store/recipe/custom-variables.utils";
import { currentRecipeCustomVariablesSelector, customVariableRelativeParameterOptionsSelector, customVariableRelativeVariableOptionsSelector, customVariableTransformationOptionsSelector, flatStepsSelector, } from "store/recipe/recipe.selectors";
import { processVariablesSelector } from "store/global/global.selectors";
import { getRecipeTimestamps } from "store/recipe/recipe.utils";
const SingleValueFormulaContent = ({ restrictions }) => {
    const formState = useFormState();
    const customVariables = useSelector(currentRecipeCustomVariablesSelector);
    const processVariables = useSelector(processVariablesSelector);
    const relativeVariableOptions = useSelector(customVariableRelativeVariableOptionsSelector);
    const relativeParameterOptions = useSelector(customVariableRelativeParameterOptionsSelector);
    const transformationOptions = useSelector(customVariableTransformationOptionsSelector);
    const recipeSteps = useSelector(flatStepsSelector);
    const timestampOptions = useMemo(() => getRecipeTimestamps(recipeSteps), [recipeSteps]);
    const formulaValue = useMemo(() => get(formState.values, `${CustomVariableFormFields.formula}.${CustomVariableFormFields.value}`), [formState.values]);
    const formulaValueErrors = useMemo(() => get(formState.errors, `${CustomVariableFormFields.formula}.${CustomVariableFormFields.value}`), [formState.errors]);
    const valueStatus = useMemo(() => {
        const fieldsConfigured = getFormulaValueFieldsConfigured(formulaValue);
        if (formulaValueErrors) {
            return CustomVariableValueStatus.Errored;
        }
        return fieldsConfigured ? CustomVariableValueStatus.Completed : CustomVariableValueStatus.Default;
    }, [formulaValue, formulaValueErrors]);
    return (React.createElement(FormulaValue, { title: "Value", defaultOpened: true, value: getFormulaDisplayValue(relativeVariableOptions, relativeParameterOptions, formulaValue), subtitle: getFormulaValueTimingInfo(formulaValue, timestampOptions, processVariables, transformationOptions, customVariables), status: valueStatus },
        React.createElement(ValueFields, { valueFieldName: CustomVariableFormFields.value, restrictions: restrictions })));
};
export default SingleValueFormulaContent;
